import React, { Component, Fragment } from 'react';
import { Button, Modal, ModalBody, Label, ModalHeader } from 'reactstrap';
import { AvForm, AvGroup, AvInput } from 'availity-reactstrap-validation';
import i18n from '../../i18next';
import MaterialIcon from 'material-icons-react';

import { FRONT_END_URL } from '../../utils/Constants';
import PopoverCommon from '../restaurants/posmenu/common/PopoverCommon';

class CustomThemeScreen extends Component {
    constructor(props) {
        super(props);

        // Transforms the theme object into array so that it can be maped through

        let modifiedArray = [
            { primaryColor: props.themeColors.primaryColor },
            { secondaryColor: props.themeColors.secondaryColor },
            { inactiveColor: props.themeColors.inactiveColor },
            { menuuLogoColor: props.themeColors.menuuLogoColor },
            { secondaryHover: props.themeColors.secondaryHover },
            { buttonOutline: props.themeColors.buttonOutline },
            { buttonsFont: props.themeColors.buttonsFont },
            { inputsFontColor: props.themeColors.inputsFontColor },
            { chefNoteBackground: props.themeColors.chefNoteBackground },
            { inputsPlaceholderColor: props.themeColors.inputsPlaceholderColor },
            { upsellBackground: props.themeColors.upsellBackground },
            { upsellPrimaryFont: props.themeColors.upsellPrimaryFont },
            { upsellSecondaryFont: props.themeColors.upsellSecondaryFont },
            { badgeFontColor: props.themeColors.badgeFontColor },
            { tableHeadersBackground: props.themeColors.tableHeadersBackground },
            { tableHeadersFont: props.themeColors.tableHeadersFont },
            { primaryFontColor: props.themeColors.primaryFontColor },
            { mainTextColor: props.themeColors.mainTextColor },
            { customScrollbar: props.themeColors.customScrollbar },
            { restInfoBackground: props.themeColors.restInfoBackground },
            { menuBackground: props.themeColors.menuBackground },
            { menuItemsBackground: props.themeColors.menuItemsBackground }
        ];

        this.state = {
            theme: modifiedArray,
            customerFrontEndTheme: {
                type: 'CUSTOM',
                primaryColor: props.themeColors.primaryColor,
                secondaryColor: props.themeColors.secondaryColor,
                inactiveColor: props.themeColors.inactiveColor,
                secondaryHover: props.themeColors.secondaryHover,
                buttonOutline: props.themeColors.buttonOutline,
                customScrollbar: props.themeColors.customScrollbar,
                restInfoBackground: props.themeColors.restInfoBackground,
                chefNoteBackground: props.themeColors.chefNoteBackground,
                menuBackground: props.themeColors.menuBackground,
                menuItemsBackground: props.themeColors.menuItemsBackground,
                primaryFontColor: props.themeColors.primaryFontColor,
                mainTextColor: props.themeColors.mainTextColor,
                inputsFontColor: props.themeColors.inputsFontColor,
                inputsPlaceholderColor: props.themeColors.inputsPlaceholderColor,
                backGroundImageFilePath: props.themeColors.backGroundImageFilePath,
                imageBackground: props.themeColors.imageBackground,
                menuuLogoColor: props.themeColors.menuuLogoColor,
                buttonsFont: props.themeColors.buttonsFont,
                upsellBackground: props.themeColors.upsellBackground,
                upsellPrimaryFont: props.themeColors.upsellPrimaryFont,
                upsellSecondaryFont: props.themeColors.upsellSecondaryFont,
                tableHeadersBackground: props.themeColors.tableHeadersBackground,
                tableHeadersFont: props.themeColors.tableHeadersFont,
                fontFamily: props.themeColors.fontFamily ? props.themeColors.fontFamily : 'Roboto',
                fontWeight: props.themeColors.fontWeight,
                fontStyle: props.themeColors.fontStyle,
                fontVariant: props.themeColors.fontVariant,
                badgeFontColor: props.themeColors.badgeFontColor
            },
            backgroundImagePreview: this.props.themeColors.backGroundImageFilePath instanceof File ? URL.createObjectURL(this.props.themeColors.backGroundImageFilePath) : null,
            activePopoverOpen: false,
            active: false
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.toggleActivePopover = this.toggleActivePopover.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.themeColors.backGroundImageFilePath !== this.props.themeColors.backGroundImageFilePath) {
            this.setState({
                ...this.state,
                customerFrontEndTheme:
                {
                    ...this.state.customerFrontEndTheme,
                    backGroundImageFilePath:
                        this.props.themeColors.backGroundImageFilePath
                }
            })
        }
    }

    handleChange({ target }) {
        let targetValue = target.value;

        if (target.name === 'imageBackground'
            || target.name === 'fontWeight'
            || target.name === 'fontStyle'
            || target.name === 'fontVariant') {

            targetValue = target.checked;
        }

        this.setState({
            customerFrontEndTheme: {
                ...this.state.customerFrontEndTheme,
                [target.name]: targetValue
            }
        });
    };

    uploadBackgroundImage(event) {
        event.preventDefault();
        const file = event.target.files[0];

        if (file !== undefined) {                          // file === undefined when you click cancel
            this.setState({
                ...this.state,
                customerFrontEndTheme: { ...this.state.customerFrontEndTheme, backGroundImageFilePath: file },
                backgroundImagePreview: URL.createObjectURL(file)
            });
        }
    }

    deleteBackgroundImage = () => {
        if (this.state.backgroundImagePreview) {
            if(this.state.customerFrontEndTheme.imageBackground) {
                document.getElementById('imageBackground').click();
            }
            this.setState({
                ...this.state,
                backgroundImagePreview: null,
                customerFrontEndTheme: { ...this.state.customerFrontEndTheme, backGroundImageFilePath: null, imageBackground: false }
            })
        } else if (this.state.customerFrontEndTheme.backGroundImageFilePath) {
            if(this.state.customerFrontEndTheme.imageBackground) {
                document.getElementById('imageBackground').click();
            }
            this.props.deleteBackgroundImage(this.props.themeColors.id);
        }
    }

    handleSubmit() {
        this.props.handleSubmit(this.state.customerFrontEndTheme);
        this.props.onToggle('customTheme');
    }

    renderBackgroundImages() {
        const { figure, brandBannerLabel, brandBanner, brandBannerSpecifications } = style;
        const { backgroundImagePreview } = this.state;
        const { backGroundImageFilePath } = this.state.customerFrontEndTheme;
        let imageSrc;
        let labelStyle;
        let imgStyle;

        if (backgroundImagePreview !== null) {
            imageSrc = backgroundImagePreview;
            labelStyle = '';
            imgStyle = { width: '100%', height: '100%', objectFit: 'cover', zIndex: 1 };
        } else if (backGroundImageFilePath === null) {
            imageSrc = backgroundImagePreview;
            labelStyle = 'coloured-label'
            imgStyle = { height: '100%', objectFit: 'cover', zIndex: 1 };
        } else {
            imageSrc = `${FRONT_END_URL}/${backGroundImageFilePath}`;
            labelStyle = '';
            imgStyle = { width: '100%', height: '100%', objectFit: 'cover', zIndex: 1 }
        }

        return (
            <div style={{ position: 'relative', width: '100%' }}>
                <figure style={figure}>
                    {
                        this.state.backgroundImagePreview || this.state.customerFrontEndTheme.backGroundImageFilePath ?
                            <div style={style.deleteButton} onClick={() => { this.deleteBackgroundImage() }}><MaterialIcon
                                icon="delete_outline" color="#cdcdcd" size={30} /></div> :
                            null
                    }
                    <input id="backgroundImagePreview" value={''} className="custom-file-input" type="file" name="backgroundImagePreview" onChange={(event) => this.uploadBackgroundImage(event)} />
                    <label className={labelStyle} style={brandBannerLabel} for="backgroundImagePreview">
                        <div style={brandBanner}>
                            <span><MaterialIcon icon="local_see" size={30} /></span>
                            {i18n.t('common:buttons.fileUpload')}
                            <div style={brandBannerSpecifications}>{i18n.t('screens:brandScreen.specificationBackgroundImage')}</div>
                        </div>
                    </label>
                    <img style={imgStyle} src={imageSrc} />
                </figure>
            </div>
        );
    }

    renderSetImageForBackground() {
        return (
            <AvGroup style={{ width: '100%', display: 'flex', flexDirection: 'row', marginTop: 12 }}>
                <AvInput id="imageBackground" type="checkbox" name='imageBackground'
                    style={{ display: 'flex', position: 'relative', margin: '0.4rem 0 0 0' }}
                    value={this.state.customerFrontEndTheme.imageBackground}
                    onChange={this.handleChange}
                    disabled={!this.state.backgroundImagePreview && !this.state.customerFrontEndTheme.backGroundImageFilePath}
                />
                <Label for='imageBackground' style={{ paddingLeft: 15 }}>{i18n.t(`screens:customFrontendThemeScreen.useImage`)}</Label>
            </AvGroup>
        );
    }

    toggleActivePopover() {
        this.setState({
            activePopoverOpen: !this.state.activePopoverOpen
        });
    }

    renderActivePopover() {
        return (
            <PopoverCommon
                isOpen={this.state.activePopoverOpen}
                target="active"
                toggle={this.toggleActivePopover}
                textContent={i18n.t(`screens:customFrontendThemeScreen.warningFontsMessage`)}
                styles={this.props.styles}
            />
        );
    }

    renderFontInputs() {
        const { popoverStyle } = style;
        return (
            <Fragment>
                <AvGroup row style={{ width: '100%', display: 'flex', alignItems: 'center', margin: '0px auto 5px' }}>
                    <Label style={{ width: '40%', marginBottom: 0 }} >{i18n.t(`screens:customFrontendThemeScreen.selectFont`)}</Label>
                        <span onClick={this.toggleActivePopover} id="active" style={popoverStyle} >
                            <MaterialIcon icon="help" color="#ff990a" size={20} />
                        </span>
                        {this.renderActivePopover()}
                    <AvInput
                        style={{ width: '50%', fontFamily: this.state.customerFrontEndTheme.fontFamily }}
                        type="select" name='fontFamily' placeholder="Select Font"
                        value={this.state.customerFrontEndTheme.fontFamily}
                        onChange={this.handleChange} required >
                        {this.renderFontOptions()}
                    </AvInput>
                </AvGroup>
                <div style={{ display: 'flex' }}>
                    <AvGroup style={{ width: '100%', display: 'flex', flexDirection: 'row', marginTop: 12 }}>
                        <AvInput type="checkbox" name='fontWeight'
                            style={{ display: 'flex', position: 'relative', margin: '0.4rem 0 0 0' }}
                            value={this.state.customerFrontEndTheme.fontWeight}
                            onChange={this.handleChange}
                        />
                        <Label for='fontWeight' style={{ paddingLeft: 15, fontWeight: 'bold' }}>{i18n.t(`screens:customFrontendThemeScreen.bold`)}</Label>
                    </AvGroup>
                    <AvGroup style={{ width: '100%', display: 'flex', flexDirection: 'row', marginTop: 12 }}>
                        <AvInput type="checkbox" name='fontStyle'
                            style={{ display: 'flex', position: 'relative', margin: '0.4rem 0 0 0' }}
                            value={this.state.customerFrontEndTheme.fontStyle}
                            onChange={this.handleChange}
                        />
                        <Label for='fontStyle' style={{ paddingLeft: 15, fontStyle: 'italic' }}>{i18n.t(`screens:customFrontendThemeScreen.italic`)}</Label>
                    </AvGroup>
                    <AvGroup style={{ width: '100%', display: 'flex', flexDirection: 'row', marginTop: 12 }}>
                        <AvInput type="checkbox" name='fontVariant'
                            style={{ display: 'flex', position: 'relative', margin: '0.4rem 0 0 0' }}
                            value={this.state.customerFrontEndTheme.fontVariant}
                            onChange={this.handleChange}
                        />
                        <Label for='fontVariant' style={{ paddingLeft: 15, textTransform: 'uppercase' }}>{i18n.t(`screens:customFrontendThemeScreen.uppercase`)}</Label>
                    </AvGroup>
                </div>
            </Fragment>
        )
    }

    renderFontOptions() {
        let fonts = ['Roboto', 'Oswald', 'Anton', 'Lobster', 'Arvo', 'Abril Fatface', 'Amatic SC', 'Special Elite', 'Russo One'];
        return fonts.map((font) => {
            return (
                <option style={{ fontFamily: font }} value={font}>{font}</option>
            )
        })
    }

    renderModalBody() {

        return (
            <ModalBody style={{ display: 'flex' }}>
                <AvForm onValidSubmit={this.handleSubmit} style={{ display: 'flex', width: '100%' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', padding: '5px 10px 0px', width: '35%' }}>
                        {
                            this.state.theme.map((item, i) => {
                                let itemName = Object.keys(item)[0];

                                if (i <= 10) {
                                    return (
                                        <AvGroup key={`colorItem${i}`} row style={{ width: '100%', display: 'flex', alignItems: 'center', margin: '0px auto 5px' }}>
                                            <Label style={{ width: '45%' }} >{i18n.t(`screens:customFrontendThemeScreen.${itemName}`)}</Label>
                                            <AvInput
                                                style={{ width: '35%' }}
                                                type="text" name={itemName} placeholder="Enter color"
                                                value={this.state.customerFrontEndTheme[itemName]}
                                                onChange={this.handleChange} required />
                                            <div style={{ width: 'calc(20% - 5px)', height: 46, border: '1px solid #ced4da', marginLeft: 5, background: this.state.customerFrontEndTheme[itemName] }}></div>
                                        </AvGroup>
                                    );
                                }
                            })
                        }
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', width: '35%', marginLeft: 10 }}>
                        <div>
                            {
                                this.state.theme.map((item, i) => {
                                    let itemName = Object.keys(item)[0];

                                    if (i > 10) {
                                        return (
                                            <AvGroup key={`colorItem${i}`} row style={{ width: '100%', display: 'flex', alignItems: 'center', margin: '0px auto 5px' }}>
                                                <Label style={{ width: '45%' }} >{i18n.t(`screens:customFrontendThemeScreen.${itemName}`)}</Label>
                                                <AvInput
                                                    style={{ width: '35%' }}
                                                    type="text" name={itemName} placeholder="Enter color"
                                                    value={this.state.customerFrontEndTheme[itemName]}
                                                    onChange={this.handleChange} required />
                                                <div style={{ width: 'calc(20% - 5px)', height: 46, border: '1px solid #ced4da', marginLeft: 5, background: this.state.customerFrontEndTheme[itemName] }}></div>
                                            </AvGroup>
                                        );
                                    }
                                })
                            }
                            {/* <div>
                                {this.renderFontInputs()}
                                <label style={{ marginTop: 15 }}>Primary Background Image</label>
                                {this.renderBackgroundImages()}
                                {this.renderSetImageForBackground()}
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: 10 }}>
                                <p style={{ fontSize: 12, color: '#373737' }}>* Colors can use HEX, RGB and HSL values.</p>
                                <Button color="primary" sm={12} style={Object.assign({}, this.props.styles.saveButton)}>
                                    <span>Set Theme</span>
                                </Button>
                            </div> */}
                        </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', width: '28%', marginLeft: 20 }}>
                        <div>
                            {this.renderFontInputs()}
                            <label style={{ marginTop: 15 }}>{i18n.t(`screens:customFrontendThemeScreen.primaryImage`)}</label>
                            {this.renderBackgroundImages()}
                            {this.renderSetImageForBackground()}
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: 10 }}>
                            <p style={{ fontSize: 12, color: '#373737' }}>{i18n.t(`screens:customFrontendThemeScreen.colorsCanUse`)}</p>
                            <Button color="primary" sm={12} style={Object.assign({}, this.props.styles.saveButton)}>
                                <span>{i18n.t(`screens:customFrontendThemeScreen.setTheme`)}</span>
                            </Button>
                        </div>
                    </div>
                </AvForm>
            </ModalBody>
        );
    }

    render() {

        return (
            <Modal dialogClassName='modal-custom-size' isOpen={this.props.isOpen} toggle={() => this.props.onToggle('customTheme')} className="customTheme" >
                <ModalHeader toggle={() => this.props.onToggle('customTheme')}>
                    {i18n.t('screens:customFrontendThemeScreen.headline')}
                </ModalHeader>
                {this.renderModalBody()}
            </Modal>
        );
    }
}

export default CustomThemeScreen;

const style = {
    figure: {
        display: 'flex',
        height: 290,
        width: '100%',
        overflow: 'hidden',
        background: 'rgb(248, 248, 248)'
    },

    brandBannerLabel: {
        width: '50%',
        left: '55%',
        textAlign: 'center'
    },

    brandBanner: {
        display: 'flex',
        flexFlow: 'row wrap',
        justifyContent: 'center'
    },
    brandBannerSpecifications: {
        fontSize: 12
    },
    deleteButton: {
        position: 'absolute',
        top: '10px',
        right: '10px',
        cursor: 'pointer',
        zIndex: 2
    },
    popoverStyle: {
        cursor: 'pointer',
        width: '10%',
        textAlign: 'center'
    }
}




// WEBPACK FOOTER //
// ./src/components/brands/CustomThemeScreen.js